// src/components/UserMultiSelectRenderer.jsx
import React, { useState, useEffect } from "react";
import {
  Paper,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import axios from "axios";

function UserMultiSelectRenderer({
  module,
  companyId, // Passed from FormRenderer (set from confirmEmail/fetchEmail)
  responses,
  onChange,
  isEditable,
}) {
  const [availableUsers, setAvailableUsers] = useState([]);
  const API_BASE_URL = "https://formbuilderapi.getforsite.com";

  useEffect(() => {
    const fetchUsers = async () => {
      if (companyId) {
        try {
          const response = await axios.get(`${API_BASE_URL}/api/users`, {
            params: { company_id: companyId },
          });
          setAvailableUsers(response.data.users);
        } catch (error) {
          console.error("Error fetching users:", error);
        }
      }
    };
    fetchUsers();
  }, [companyId, API_BASE_URL]);

  // Use responses[module.id] as the value
  const selectedUserIds = responses["linked_users"] || [];

  const handleSelectionChange = (e) => {
    onChange(module.id, e.target.value);
  };

  return (
    <Paper elevation={3} sx={{ padding: 2, marginY: 2 }}>
      <Typography variant="subtitle1">
        {module.label || "Select Users"}
      </Typography>
      <FormControl fullWidth variant="outlined">
        <InputLabel>{module.label || "Select Users"}</InputLabel>
        <Select
          label={module.label || "Select Users"}
          multiple
          value={selectedUserIds}
          onChange={handleSelectionChange}
          disabled={!isEditable}
          renderValue={(selected) =>
            selected
              .map((userId) => {
                const user = availableUsers.find((user) => user.id === userId);
                return user ? `${user.first_name} ${user.last_name}` : "";
              })
              .join(", ")
          }
        >
          {availableUsers.length > 0 ? (
            availableUsers.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                <Checkbox checked={selectedUserIds.includes(user.id)} />
                <Typography>
                  {user.first_name} {user.last_name}
                </Typography>
              </MenuItem>
            ))
          ) : (
            <MenuItem value="" disabled>
              {companyId ? "Loading users..." : "Company ID not set"}
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </Paper>
  );
}

export default UserMultiSelectRenderer;
